import { i18n } from '@/plugins/i18n'

export const marketingProfitTypes = {
    SPECIFIC_USER_PROFIT:1,
    SPECIFIC_REFERER_PROFIT:2,
    DEFAULT_PROFIT:3,
}

export const typeStr = {
    SPECIFIC_USER_PROFIT: i18n.t('marketing.marketing_setting.specific_user_profit'),
    SPECIFIC_REFERER_PROFIT: i18n.t('marketing.marketing_setting.specific_referer_profit'),
    DEFAULT_PROFIT: i18n.t('marketing.marketing_setting.default_profit'),
    get(status) {
        let type_str = null;
        Object.keys(marketingProfitTypes).forEach(function (item, index) {
            if(marketingProfitTypes[item] === status) {
                type_str = typeStr[item]
            }
        })

        return type_str
    }
}
